// extracted by mini-css-extract-plugin
export default {"vicri-container-external":"VicriWidgetExternal_vicri-container-external__OuCeM"};